import React, { useEffect, useState } from 'react';
import Loader from '../../common/Loader';
import { useFetchMatch } from '../../data/fetchMatch';
import Competition from '../../live/live-suite/Competition';

function PrematchHomeCompetition(props) {
    const match = props.match;
    const [aggregata, setAggregata] = useState(match.openAggregata);
    const [aggregataFetch, setAggregataFetch] = useState(match.openAggregata);
    let [macrogruppo, setMacrogruppo] = useState(null);
    let [showLoader, setShowLoader] = useState(true);

    useEffect(function() {
        setMacrogruppo(null);
        setAggregataFetch(match.openAggregata);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [match]);

    const [state, dispatch] = useFetchMatch(match, aggregataFetch, match.isLive, false);
    let [data, setData] = useState(null);
    
    useEffect(function() {
        if (showLoader && !state.isLoading && !state.isError) {
            setShowLoader(false);
        }
    }, [showLoader, state]);

    useEffect(function() {
        if (!state.isLoading && !state.isError) {
            setData(state.data);
            setAggregata(aggregataFetch);
        }
    }, [state, aggregataFetch]);

    if (state.isLoading || state.isError) {
        if (showLoader) {
            return <Loader error={state.isError} />;
        }
    }

    if (data == null) {
        data = state.data;
    }

    function changeMacrogruppo(mg) {
        if (mg.id !== macrogruppo.id) {
            setMacrogruppo(mg);
            setAggregataFetch(mg.aggregate[0].idAggregata);
            dispatch({ type: 'FETCH_INIT' });
        }
    }

    function changeAggregata(ag) {
        if (ag !== aggregata) {
            setAggregataFetch(ag);
            dispatch({ type: 'FETCH_INIT' });
        }
    }

    if (data.macrogruppi.length > 0 && macrogruppo == null) {
        macrogruppo = data.macrogruppi.find(mg => mg.id === match.openMacrogruppo);
    }

    return (
        <Competition {...match} {...data} aggregata={aggregata} setAggregata={changeAggregata} macrogruppo={macrogruppo} setMacrogruppo={changeMacrogruppo} />
    );
}
            
export default PrematchHomeCompetition;